export default "__VITE_ASSET__9ea9c9e0__"